import React, { useState } from 'react';
import './styles.css'
import MapComponent from './components/mapComponent';
import JsonPaths from './../../data/map.json';
import Footer from './../../components/footer/footer';
import { useDispatch, useSelector } from 'react-redux';
import { generateVisit } from './../../actions/initiativeActions';

function Initiative() {

    const dispatch = useDispatch();
    const showpurpose = useSelector(state => state.initiative.showpurpose);

    return (
        <React.Fragment>
            {
                showpurpose && <div className="fixedBackground" style={{ background: "rgba(0,0,0,0.50)" }}>
                    <div style={{ display: "flex", flexDirection: "column", background: "white", width: "90%", boxShadow: "0 0 6px 1px rgba(0, 0, 0, 0.14)", padding: 10, border: "solid 0.5px #b9b9b9", maxWidth: 600, border: "solid 5px #9edcf8" }}>
                        <div style={{ textAlign: "center", fontSize: 23, fontWeight: "bold", margin: "10px" }} >Creemos Juntos la mejor versión de nuestro Valle</div>
                        <div style={{ textAlign: "center", fontSize: 14, fontWeight: "bold" }}>

                            <div></div>
                            ESTAMOS FORMULANDO EL PLAN DE DESARROLLO DEL VALLE DEL CAUCA 2024-2027 Y TU PARTICIPACIÓN ES IMPORTANTE. <div></div>
                            Juntos, sumando esfuerzos, reconociendo lo que somos, lo que sabemos y tenemos, podemos mejorar la calidad de vida de los, les y las personas que habitan el Valle del Cauca.
                          



                        </div>
                        <video src={require('./../../assets/guia.mp4')} autoPlay controls></video>
                        <div className="row m-0 mt-2 justify-content-center">
                            <div className="bt-1" style={{ background: "white" }} onClick={() => dispatch(generateVisit())}>Aceptar</div>
                        </div>
                    </div>
                </div>
            }
            <MapComponent jsonPaths={JsonPaths} />
            <Footer />
        </React.Fragment>
    )
}

export default Initiative;